/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planner_Notes_HelpInputs */

const en_planner_notes_help = /** @type {(inputs: Planner_Notes_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. "vegetarian, we eat out on Friday"`)
};

const de_planner_notes_help = /** @type {(inputs: Planner_Notes_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. „vegetarisch, Freitag essen wir auswärts“`)
};

/**
* | output |
* | --- |
* | "e.g. \"vegetarian, we eat out on Friday\"" |
*
* @param {Planner_Notes_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const planner_notes_help = /** @type {((inputs?: Planner_Notes_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planner_Notes_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_planner_notes_help(inputs)
	return en_planner_notes_help(inputs)
});